import { Conferences } from '@/modules/conferences/types';
import { all_roles } from '@/utils';

const access_roles = {
  [Conferences.Pages.CONFERENCES]: all_roles,
  [Conferences.Pages.NEW_CONFERENCE]: all_roles,
  [Conferences.Pages.EDIT_CONFERENCE]: all_roles,
  [Conferences.Pages.CONFERENCE_DETAIL]: all_roles,
};

export default access_roles;
